<template>
  <div>
    <div align="left">
      <br />
      <h5 class="text-primary font-weight-bold">Frequently Asked Question</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Frequently Asked Question</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label mb-n1"
            label="Image"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>{{image.name || 'Name'}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(1000px x 400px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="image"
                    name="image"
                    v-validate="'image|minimalDimensions:1000,400|size:2000|ext:jpg,png,gif,jpeg'"
                    style="display: none"
                    v-on:change="onChangeimage()"
                  />
                  <b-button
                    @click="$refs.image.click()"
                    v-show="!image && !items.image"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="image || items.image"
                    variant="primary"
                    @click="modalImage = !modalImage"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.image.click()"
                    v-show="image || items.image"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category"
            label-for="input-1"
          >
            <select
              class="custom-select mt-2"
              v-validate="'required'"
              name="category"
              data-vv-as="Category"
              v-model="items.category.id"
              required
            >
              <option value>Select Category</option>
              <option
                v-for="option in options"
                :key="option"
                :value="option.id"
              >{{option.category_name.id}}</option>
            </select>
            <b-form-invalid-feedback id="input-live-feedback">{{ veeErrors.first('category') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Question (Bahasa)"
            label-for="input-1"
          >
            <input
              id="input-1"
              v-model="items.question.id"
              v-validate="'required'"
              name="question_id"
              data-vv-as="Question Bahasa"
              class="form-control"
              placeholder="Question in Bahasa Indonesia"
            />
            <b-form-invalid-feedback
              id="input-question_id-feedback"
            >{{ veeErrors.first('question_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Question (English)"
            label-for="input-1"
          >
            <input
              placeholder="Question in English"
              v-model="items.question.en"
              v-validate="'required'"
              name="question_en"
              data-vv-as="Question English"
              class="form-control"
            />
            <b-form-invalid-feedback
              id="input-question_en-feedback"
            >{{ veeErrors.first('question_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Answer (Bahasa)"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              placeholder="Answer in Bahasa"
              class="form-control ck-editor__editable ck-editor__editable_inline"
              v-model="items.answer.id"
              data-vv-as="Answer English"
              v-validate="'required'"
              name="answer_id"
              :config="editorConfig"
            ></ckeditor>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('answer_id') }}</p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Answer (English)"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              tag-name="textarea"
              placeholder="Answer in English"
              name="answer_en"
              class="form-control ck-editor__editable ck-editor__editable_inline"
              v-model="items.answer.en"
              data-vv-as="Answer English"
              v-validate="'required'"
              :config="editorConfig"
            ></ckeditor>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('answer_en') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="Meta Description Bahasa"
            label-for="input-1"
          >
            <textarea
              id="input-1"
              type="text"
              class="form-control"
              v-validate="{required: true, max: 159}"
              name="meta_description_id"
              data-vv-as="Meta Description Bahasa"
              v-model="items.meta_description.id"
              placeholder="Meta Description Bahasa"
            />
            <b-form-invalid-feedback
              id="input-meta_description_id-feedback"
            >{{ veeErrors.first('meta_description_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="Meta Description English"
            label-for="input-1"
          >
            <textarea
              id="input-1"
              type="text"
              class="form-control"
              v-validate="{required: true, max: 159}"
              name="meta_description_en"
              data-vv-as="Meta Description English"
              v-model="items.meta_description.en"
              placeholder="Meta Description English"
            />
            <b-form-invalid-feedback
              id="input-meta_description_en-feedback"
            >{{ veeErrors.first('meta_description_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button variant="primary" class="mr-3" :disabled="loading" @click="put()" size="lg">Save</b-button>
          <router-link :to="{name: 'FaqContent'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-show="!image" v-if="items.image" width height="400px" :src="items.image" />
      <img v-show="image" v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";

export default {
  mixins: [mixInCkeditor],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      items: [],
      isHiddenEnglish: false,
      isHiddenBahasa: false,
      modalImage: false,
      selected: "",
      widthImage: null,
      heightImage: null,
      urlImage: "",
      image: "",
      options: []
    };
  },
  beforeCreate() {
    this.$store.dispatch("FaqModule/getFaq", this.$route.params.id);
    this.$store.dispatch("FaqModule/getFaqCategoryDatas", { root: true });
  },
  created() {
    this.$store.watch(
      state => state.FaqModule.faq_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
    this.$store.watch(
      state => state.FaqModule.faq_category,
      (newValue, oldValue) => {
        this.options = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  mounted() {
    this.$store.watch(
      state => state.FaqModule.faq_category,
      (newValue, oldValue) => {
        this.options = newValue;
      }
    );
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Faq Content!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("category_id", this.items.category.id);
              formData.append("question_id", this.items.question.id);
              formData.append("question_en", this.items.question.en);
              formData.append("answer_id", this.items.answer.id);
              formData.append("answer_en", this.items.answer.en);
              formData.append("meta_description_id", this.items.meta_description.id);
              formData.append("meta_description_en", this.items.meta_description.en);
              formData.append("image", this.image);
              this.$store
                .dispatch("FaqModule/putFaq", {
                  id: this.$route.params.id,
                  formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "FaqContent" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.serverError = error.response.data;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        }
      });
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
